<template>
  <div class="rounded-full w-56 h-56 block bg-cover bg-center cursor-pointer" :style="{ 'background-image': `url(${imageData})` }" @click="chooseImage">
    <span
      v-if="!imageData"
      class="rounded-full flex justify-center items-center bg-gray-100 hover:bg-gray-200 w-full h-full border border-primary-500 border-dashed text-primary-500"
    >
      Select Image
    </span>
    <input class="rounded-full hidden" ref="fileInput" type="file" accept="image/jpeg, image/png" @input="onSelectFile" />
  </div>
</template>

<script>
export default {
  emits: ["update:modelValue"],
  name: "ImageInput",
  data() {
    return {
      imageData: null,
    };
  },
  methods: {
    chooseImage() {
      this.$refs.fileInput.click();
    },
    onSelectFile() {
      var input = this.$refs.fileInput;
      var files = input.files;
      if (files && files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("update:modelValue", files[0]);
      }
    },
  },
};
</script>
